import logo from './logo.svg';
import './App.css';
import ReviewForm from './reviewForm';

function App() {
  return (
    <div className="App">
      <header className="App-header">
       <ReviewForm />
      </header>
    </div>
  );
}

export default App;
